
import { NestedValueExtractor } from "../../general_components/content_management/list_view/listView";
import { addNotification } from "../../supplementary_components/store";
import { generateColumn, TRUCK_SECTION_UPDATE } from '../../supplementary_components/itemEditMethods';
import { parseTasks } from "../../general_components/content_management/task_list/taskListElements/diagramView";
import { Details, ThisWeeksPerformanceBlock, LatestLoadsBlock, TasksBlock, MaintenanceInvoicesBlock, FuelCardSection } from "./truckPageConfComponents";
import { TRUCK_BLOCK, resolveTruckOverviewSection } from "./truckPageLayout";
import { statusCodeGenerator } from "../../main_board_components/teamCard/truckCard/truckCardComponents/statusSection";
import { API_ROOT } from "../../supplementary_components/requests";
import { trackingColumns, createTrackingSession, applyTrackingSessionAfterSave } from "../../supplementary_components/trackingIdLookup";
import { LatestActivitiesSection } from "../../general_components/content_management/item_page/latestActivitiesSection";
import { generateRandomString, dateFormatter } from "../../supplementary_components/supplementaryMethods";
import { canSeeLoadRates } from "../../supplementary_components/userDataDelegate";
import { thisWeeksLoadsHaveVisibleRates } from "../../main_board_components/boardStore";
import { localDateToUSFormat } from "../../general_components/content_management/item_page/driver_page_components/payoutAdjustmentsSection";
import { dateStringToLocalDateString } from "../reports/weeklyReports";
import { equipmentPurchaseColumns, confirmIfPurchaseTypeDropsHistory } from "../reports/equipmentPaymentFields";

export class TRUCK_PAGE_OBJECT {
    Details = ()=> {
        return Details(this);
    }
    supplementaryInfoSectionColumns = (trackingSession)=>{
        return [
            {
                notInAddForm:true,
                label: 'Status',
                name: "truckStatus",
                val: this.data['truckStatus'] ,
                type: "select",
                dataset: ["Active", "Inactive", "Terminated", "Sold"],
                defaultValue:()=>{
                    return this.data['truckStatus'];
                }
            },
            {
                label: "Truck Type",
                val: this.data['truckType'],
                nameInAddConfForm: 'truckType',
                defaultValue:()=>{
                    return this.data['truckType'];
                }
            },
            ...trackingColumns(this, 'trucks', trackingSession),
        ]
    }
    truckDetailsSectionColumns = ()=>{
        return [
            {
                label: 'Truck Number',
                val: this.truckNumber,
                nameInAddConfForm: 'truckNumber',
                defaultValue:()=>{
                    return this.truckNumber
                }
            },
            {
                label: 'Make',
                val: this.data['make'],
                nameInAddConfForm: 'make',
                defaultValue:()=>{
                    return this.data['make']
                }
            },
            {
                label: 'Model',
                val: this.data['model'],
                nameInAddConfForm: 'model',
                defaultValue:()=>{
                    return this.data['model']
                }
            },
            {
                label: 'Vin',
                val: this.data['vin'],
                nameInAddConfForm: 'vin',
                defaultValue:()=>{
                    return this.data['vin']
                }
            },
            {
                label: 'Year',
                val: this.data['year'],
                nameInAddConfForm: 'year',
                defaultValue:()=>{
                    return this.data['year']
                }
            },
            
            {
                label: 'License Plate',
                val: this.data['licensePlate'],
                nameInAddConfForm: 'licensePlate',
                defaultValue:()=>{
                    return this.data['licensePlate']
                }
            },
            generateColumn(this.data, true, 'I-Pass ID', 'ipassId'),
            generateColumn(this.data, true, 'Pike-Pass ID', 'pikePassId'),
            {
                notInAddForm:true,
                label: "In-service date",
                name: "inServiceDate",
                mandatory: true,
                autoComplete: "off",
                calendarPickType: "singleDate",
                hasConstraints: true,
                checks: [
                    (value) => {
                        const res = dateFormatter(value);
                        if (!value || res.date === null) {
                            return 'Invalid Input';
                        }
                        return null;
                    }
                ],
                onblur: (val) => dateFormatter(val).date || val,
                defaultValue: () => this.data.inServiceDate ? localDateToUSFormat(this.data.inServiceDate) : "",
                val: this.data.inServiceDate ? localDateToUSFormat(this.data.inServiceDate) : "-",
                processBeforeSending: (val) => val !== null && val !== "" ? dateStringToLocalDateString(val) : null,
            },
            {
                notInAddForm:true,
                label: "Out of fleet date",
                name: "outOfFleetDate",
                autoComplete: "off",
                calendarPickType: "singleDate",
                hasConstraints: true,
                customDisplayMode: (this.data['truckStatus'] === "Terminated" || this.data['truckStatus'] === "Sold") ? "block" : "none",
                checks: [
                    (value) => {
                        if (value === '' || value == null) return null;
                        const res = dateFormatter(value);
                        if (res.date === null) {
                            return 'Invalid Input';
                        }
                        return null;
                    }
                ],
                onblur: (val) => {
                    if (!val) return val;
                    return dateFormatter(val).date || val;
                },
                defaultValue: () => this.data.outOfFleetDate ? localDateToUSFormat(this.data.outOfFleetDate) : "",
                val: this.data.outOfFleetDate ? localDateToUSFormat(this.data.outOfFleetDate) : "-",
                processBeforeSending: (val) => val !== null && val !== "" ? dateStringToLocalDateString(val) : null,
            },
            ...equipmentPurchaseColumns(this),
        ]
    }
    constructor(){
        this.getLink = API_ROOT+'trucks/page/';
        this.columnProportions = "25rem 1fr 0.6fr";
    }
    setData(data){
        if(data.trackingProviderOptions === undefined && this.data?.id === data.id){
            data.trackingProviderOptions = this.data.trackingProviderOptions;
        }
        if(data.lessorName === undefined && this.data?.id === data.id){
            data.lessorName = this.data.lessorName;
        }
        this.data = data;
        this.id = data['id'];
        this.truckNumber = data['truckNumber'];
        this.canSeeRates = canSeeLoadRates() && thisWeeksLoadsHaveVisibleRates(data.thisWeeksLoads);
        this.trailerNumber = NestedValueExtractor(data, [["currentTrailer", "trailerNumber"]]);
        this.firstDriverFN = NestedValueExtractor(data, [['driver1', 'lastName'], ', ', ["driver1", "firstName"], ' ', ["driver1", "middleName"]]).replace(/ -$/, "");
        this.firstDriverSN = NestedValueExtractor(data, [["driver1", "firstName"], ' ', ['driver1', 'lastName']]);
        
        this.secondDriverFN = NestedValueExtractor(data, [['driver2', 'lastName'], ', ', ["driver2", "firstName"], ' ', ["driver2", "middleName"]]).replace(/ -$/, "");
        this.secondDriverSN = NestedValueExtractor(data, [["driver2", "firstName"], ' ', ['driver2', 'lastName']]);
        
        this.fuelCard = data['fuelCard'];
        this.dispatcher = NestedValueExtractor(data, [["dispatcher", "firstName"], ' ', ["dispatcher", "lastName"]]);
        
        
        
        if(this.data['tasks'] && this.data['tasks'].length > 0 && typeof(this.data['tasks'][0]) === 'string'){
            this.data['tasks'] = parseTasks(this.data['tasks']);
        }
        
        this.status = data['status'] ? data['status'] : statusCodeGenerator(this.data['tasks']);
        this.currentDrivers = (shortVersion)=>{
            const namesArray = [];
            const fdn = shortVersion ? this.firstDriverSN : this.firstDriverFN;
            const sdn = shortVersion ? this.secondDriverSN : this.secondDriverFN;
            if(fdn !== '-')namesArray.push(fdn);
            if(sdn !== '-')namesArray.push(sdn);
            return namesArray.join(' / ');
        }


        this.notes = data['notes'];
        this.header = {
            title : "Truck " + (this.truckNumber.length < 5 ? this.truckNumber : ""),
            titleVal: this.truckNumber.length < 5 ? "" : this.truckNumber,
            status : {
                value: this.status.textVal,
                colorCode: this.status.colorCode
            },
            suplementaryInfo: this.currentDrivers(true)
        };
        this.infoSections = [
            {
                title: 'Crew & Equipment',
                editAccessLevel: { key: 'TRUCKS', level: 'MANAGE' },
                copyButton: () => {
                    navigator.clipboard.writeText(`Truck: ${this.truckNumber}\n${this.trailerNumber === '-' ? '' : 'Trailer: '+this.trailerNumber+'\n'}Driver(s): ${this.currentDrivers()}\nPhone Number(s): ${NestedValueExtractor(data, [["driver1", "phoneNumber"], " / ", ["driver2", "phoneNumber"] ]).replace('- /', '').replace('/ -', '')}`)
                    addNotification({message:`Copied to clipboard`, type:'notify', duration: '1000'})
                },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        TRUCK_SECTION_UPDATE(setDataMethod, this.data.id, this.Details);
                    }
                },
                columns : this.Details()
            },
            FuelCardSection(this.data),
            {
                title: 'Overview',
                editAccessLevel: { key: 'TRUCKS', level: 'MANAGE' },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        const trackingSession = createTrackingSession();
                        TRUCK_SECTION_UPDATE((saved)=>{
                            setDataMethod(saved);
                            applyTrackingSessionAfterSave(trackingSession, saved, 'trucks');
                        }, this.data.id, ()=>this.supplementaryInfoSectionColumns(trackingSession));
                    }
                },
                columns : this.supplementaryInfoSectionColumns()
            },
            {
                title: 'Truck Details',
                editAccessLevel: { key: 'TRUCKS', level: 'MANAGE' },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        TRUCK_SECTION_UPDATE((saved)=>{
                            if (saved && this.pendingLessorName !== undefined) {
                                saved.lessorName = this.pendingLessorName;
                                this.pendingLessorName = undefined;
                            }
                            setDataMethod(saved);
                        }, this.data.id, this.truckDetailsSectionColumns, null, null, null, async (submitted) => {
                            const next = submitted?.purchaseType || null;
                            if (this.purchaseTypeConfirmed && this.purchaseTypeConfirmed === (next || '')) return;
                            const proceed = await confirmIfPurchaseTypeDropsHistory(this.data.purchaseType, next);
                            if (!proceed) return { cancelSubmission: true };
                        });
                    }
                },
                columns : this.truckDetailsSectionColumns()
            }
        ]
        this.overviewSection = resolveTruckOverviewSection({
            [TRUCK_BLOCK.PERF]: ThisWeeksPerformanceBlock(this),
            [TRUCK_BLOCK.LOADS]: LatestLoadsBlock(this),
            [TRUCK_BLOCK.TASKS]: TasksBlock(this),
            [TRUCK_BLOCK.INVOICES]: MaintenanceInvoicesBlock(this),
            [TRUCK_BLOCK.ACTIVITY]: {
                title : `Latest Activities`,
                content: ()=>{
                    return <LatestActivitiesSection type="TRUCK" objectId={this.id} refreshKey={generateRandomString(4)}  />
                },
                headerLine :true
            },
        })
        this.notesSection = {

        }
    }
}